import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { OvsComponent, QueryParamService } from '../../shared/core/ovs.core';
import { ResortDetail, ResortImageType, ResortImage } from '../../models/presentation.model';
import { ResortComponent } from '../../shared/resort.component';

@Component({
    selector: 'resort-member-message',
    templateUrl: './resort-member-message.component.html',
    styleUrls: ['./resort-member-message.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ResortMemberMessage extends ResortComponent
{
    private isExclusive_: Boolean;

    public get partnerName(): string {
        return this.configuration.Partner.LongName;
    }

    constructor( private qryParamService: QueryParamService) {
        super();
        this.isExclusive_ = this.qryParamService.resortDetailParams.isExclusive;
    }


    public get isExclusive(): Boolean {
        return this.isExclusive_;
    }
   
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-member-message/resort-member-message.component.ts